import { Accordion } from '@atlas/components';

import Icon from 'components/Icon/Icon';
import PageGroupList from 'components/PageGroupList';
import type { ComponentProps, FC } from 'react';
import { Translation } from 'utils/translations';

type SupportMenuProps = Pick<
  ComponentProps<typeof Accordion>,
  'onChangeState' | 'appearance'
> & {
  asAccordion?: boolean;
};

const SupportMenu: FC<SupportMenuProps> = ({
  asAccordion = true,
  onChangeState,
  appearance,
}) =>
  asAccordion ? (
    <Accordion
      icon={<Icon name="support.bold" />}
      title={<Translation message="support" />}
      onChangeState={onChangeState}
      appearance={appearance}
      dataId="support-menu"
    >
      <PageGroupList group="support" />
    </Accordion>
  ) : (
    <PageGroupList group="support" dataId="support-menu" />
  );

export default SupportMenu;
